import { ChangeEvent, Dispatch, MouseEvent, SetStateAction } from 'react'

import SelectOptions from '~/shared/components/SelectOptions'
import { UserField } from '~/types/user'

import styles from '~/shared/styles/Input.module.css'

import { Select } from './Select'

interface SelectBoxProps {
  name?: UserField
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
  onClick?: (event: MouseEvent<HTMLElement>) => void
  value: string
  options?: Array<{ value: string; label: string }>
  disabled?: boolean
  setHasCountriesLoaded?: Dispatch<SetStateAction<boolean>>
}

export function SelectBox({
  name,
  onChange,
  onClick,
  disabled,
  value,
  options,
  setHasCountriesLoaded,
}: SelectBoxProps): React.ReactElement {
  return (
    <Select
      className="bg-white w-full"
      disabled={disabled}
      iconColor="text-purple"
      innerClassName={`py-2 ${styles['styles']}`}
      name={name}
      onChange={onChange}
      onClick={onClick}
      value={value}
    >
      <SelectOptions fieldName={name} options={options} setHasCountriesLoaded={setHasCountriesLoaded} />
    </Select>
  )
}
